<!-- @format -->

<template>
    <BaseSlice
        id="faq"
        v-bind="navigationAttributes"
        class="gst-slice-home-faq">
        <PrismicRichText
            :field="slice.primary.title"
            class="gst-slice__title text-center" />
        <DropdownList
            :items="slice.items"
            :separator="false" />
    </BaseSlice>
</template>

<script>
import NavMixin from '@tenant/app/slices/mixins/NavMixin.js';
import DropdownList from '@tenant/app/slices/components/DropdownList.vue';

export default {
    name: 'Faq',
    components: {
        DropdownList,
    },
    mixins: [NavMixin],
    props: {
        slice: {
            type: Object,
            default: null,
        },
    },
};
</script>
